import { render, staticRenderFns } from "./ContactAuthor.vue?vue&type=template&id=5df9bccb&scoped=true&"
import script from "./ContactAuthor.vue?vue&type=script&lang=js&"
export * from "./ContactAuthor.vue?vue&type=script&lang=js&"
import style0 from "./ContactAuthor.vue?vue&type=style&index=0&id=5df9bccb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df9bccb",
  null
  
)

export default component.exports